import { defineMessages } from 'react-intl';

import { InGameCurrency, Rarity } from '#src/__generated__/globalTypes.ts';

export const scarcityMessages = defineMessages({
  common: {
    defaultMessage: 'Common',
  },
  custom_series: {
    defaultMessage: 'Custom Series',
  },
  limited: {
    defaultMessage: 'Limited',
  },
  mix: {
    defaultMessage: 'Mix',
  },
  rare: {
    defaultMessage: 'Rare',
  },
  rare_pro: {
    defaultMessage: 'Rare Pro',
  },
  super_rare: {
    defaultMessage: 'Super Rare',
  },
  unique: {
    defaultMessage: 'Unique',
  },
});

export const RANKED_SCARCITY = {
  global_cup: 0,
  custom_series: 1,
  academy1: 2,
  academy2: 3,
  academy3: 4,
  academy4: 5,
  academy5: 6,
  common: 7,
  limited: 8,
  rare: 9,
  rare_pro: 10,
  super_rare: 11,
  unique: 12,
  mix: 13,
  training: 14,
};

type RankedScarcity = keyof typeof RANKED_SCARCITY;

export function sortByRarity<T extends RankedScarcity>(items: T[]): T[];
export function sortByRarity<T>(
  items: T[],
  accessor: (it: T) => RankedScarcity
): T[];
export function sortByRarity<T>(
  items: T[],
  accessor?: (it: T) => RankedScarcity
): T[] {
  return [...(items ?? [])].sort(
    (a, b) =>
      RANKED_SCARCITY[accessor?.(b) ?? (b as RankedScarcity)] -
      RANKED_SCARCITY[accessor?.(a) ?? (a as RankedScarcity)]
  );
}

export const inGameCurrencyToRarity: Record<InGameCurrency, Rarity | null> = {
  [InGameCurrency.COMMON_XP]: Rarity.common,
  [InGameCurrency.LIMITED_XP]: Rarity.limited,
  [InGameCurrency.RARE_XP]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_XP]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_XP]: Rarity.unique,
  [InGameCurrency.OLD_CLUB_SHOP_COIN]: null,
  [InGameCurrency.COMMON_GEM]: Rarity.common,
  [InGameCurrency.COMMON_GOLDEN_WHEEL_TICKET]: Rarity.common,
  [InGameCurrency.COMMON_WHEEL_TICKET]: Rarity.common,
  [InGameCurrency.GOLDEN_WHEEL_TICKET]: Rarity.limited,
  [InGameCurrency.WHEEL_TICKET]: Rarity.limited,
  [InGameCurrency.RARE_WHEEL_TICKET]: Rarity.rare,
  [InGameCurrency.RARE_GOLDEN_WHEEL_TICKET]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_WHEEL_TICKET]: Rarity.super_rare,
  [InGameCurrency.SUPER_RARE_GOLDEN_WHEEL_TICKET]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_WHEEL_TICKET]: Rarity.unique,
  [InGameCurrency.UNIQUE_GOLDEN_WHEEL_TICKET]: Rarity.unique,
  [InGameCurrency.DIVISION_CRAFT_CLUE]: null,
  [InGameCurrency.POSITION_CRAFT_CLUE]: null,
  [InGameCurrency.COMPETITION_CRAFT_CLUE]: null,
  [InGameCurrency.COUNTRY_CRAFT_CLUE]: null,
  [InGameCurrency.FIFTY_FIFTY_CRAFT_CLUE]: null,
  [InGameCurrency.SPECIAL_EVENT_CRAFT_CLUE]: null,
  [InGameCurrency.BEST_STAR_RANK_CRAFT_CLUE]: null,
  [InGameCurrency.LIMITED_ENERGY]: Rarity.limited,
  [InGameCurrency.RARE_ENERGY]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_ENERGY]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_ENERGY]: Rarity.unique,
  [InGameCurrency.LIMITED_COUNTRY_CRAFT_CLUE]: Rarity.limited,
  [InGameCurrency.RARE_COUNTRY_CRAFT_CLUE]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_COUNTRY_CRAFT_CLUE]: Rarity.super_rare,
  [InGameCurrency.LIMITED_COMPETITION_CRAFT_CLUE]: Rarity.limited,
  [InGameCurrency.RARE_COMPETITION_CRAFT_CLUE]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_COMPETITION_CRAFT_CLUE]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_COMPETITION_CRAFT_CLUE]: Rarity.unique,
  [InGameCurrency.LIMITED_FIFTY_FIFTY_CRAFT_CLUE]: Rarity.limited,
  [InGameCurrency.RARE_FIFTY_FIFTY_CRAFT_CLUE]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_FIFTY_FIFTY_CRAFT_CLUE]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_FIFTY_FIFTY_CRAFT_CLUE]: Rarity.unique,
  [InGameCurrency.LIMITED_BEST_STAR_RANK_CRAFT_CLUE]: Rarity.limited,
  [InGameCurrency.RARE_BEST_STAR_RANK_CRAFT_CLUE]: Rarity.rare,
  [InGameCurrency.SUPER_RARE_BEST_STAR_RANK_CRAFT_CLUE]: Rarity.super_rare,
  [InGameCurrency.UNIQUE_BEST_STAR_RANK_CRAFT_CLUE]: Rarity.unique,
};
